"use strict";
exports.__esModule = true;
exports.QuoteHelperService = void 0;
var http_1 = require("../../core/http");
var quote_api_1 = require("./quote.api");
var operators_1 = require("rxjs/operators");
var fetchQuote$;
var fetchQuote = function (sessionId) {
    if (!fetchQuote$) {
        fetchQuote$ = http_1.Http.get(quote_api_1.QuoteApi.get(sessionId)).pipe(operators_1.share());
    }
    return fetchQuote$;
};
var resetCacheFetchQuote = function () { return fetchQuote$ = null; };
exports.QuoteHelperService = { fetchQuote: fetchQuote, resetCacheFetchQuote: resetCacheFetchQuote };
//# sourceMappingURL=quote-helper.service.js.map